import { ApiNewDokumentPowiazanyDalDto, EgibObject } from '@gk/gk-modules';
import { WorkspaceState } from '../../../../services/request-workspace-state/request-workspace-state.model';
import {
  DocumentationFormType,
  ExtendedApplicantRequest,
  ExtendedApplicantRequestDto,
} from '../../../../shared/base-new-request/base-new-request.model';
import {
  InvestorDetails,
  InvestorDetailsRequestDto,
} from '../../../../shared/investor-details/investor-details.model';
import { Shipping } from '../../../../shared/shipping-form/shipping-form.model';
import {
  Shrub,
  ShrubRequestDto,
  Tree,
  TreeRequestDto,
} from '../../../environmental-protection-portal/trees-and-shrubs-felling-request/services/new-request/new-request.model';

export interface TSRNNewRequestDto extends ExtendedApplicantRequestDto {
  Wlasciciele?: InvestorDetailsRequestDto[];
  WlascicielSameAsWnioskodawca?: boolean;
  Drzewa?: TreeRequestDto[];
  Krzewy?: ShrubRequestDto[];
  UsuniecieNiezwiazaneZDzialalnoscia?: boolean;
}

export class TSRNNewRequest extends ExtendedApplicantRequest {
  constructor(
    investorDetails: InvestorDetails,
    documentationForm: DocumentationFormType,
    shippingForm: Shipping,
    proxyDetailsCheckbox: boolean,
    proxyDetailsArray: InvestorDetails[],
    public owners: InvestorDetails[],
    public ownerOtherThanApplicant: boolean,
    public trees: Tree[],
    public shrubs: Shrub[],
    public nonBusinessPurposes: boolean,
  ) {
    super(
      investorDetails,
      documentationForm,
      shippingForm,
      undefined,
      undefined,
      proxyDetailsCheckbox,
      proxyDetailsArray,
    );
  }

  static fromAppToApi(
    data: TSRNNewRequest,
    parcels: EgibObject[],
    issueRanges: string[],
    files: ApiNewDokumentPowiazanyDalDto[],
  ): TSRNNewRequestDto {
    const isNewRemovalNotification =
      data.requestMode === TSRNRequestMode.NewRemovalNotification;

    return {
      ...ExtendedApplicantRequest.mapCommonFields({
        data,
        files,
        parcels: isNewRemovalNotification ? parcels : undefined,
        issueRanges: isNewRemovalNotification ? issueRanges : undefined,
      }),
      ...(isNewRemovalNotification
        ? {
            Wlasciciele: data.owners?.map((owner) =>
              InvestorDetailsRequestDto.fromAppToApi(owner),
            ),
            WlascicielSameAsWnioskodawca: !data.ownerOtherThanApplicant,
            Drzewa: data.trees.map((tree) => TreeRequestDto.fromApiToApp(tree)),
            Krzewy: data.shrubs.map((shrub) =>
              ShrubRequestDto.fromApiToApp(shrub),
            ),
            UsuniecieNiezwiazaneZDzialalnoscia: data.nonBusinessPurposes,
          }
        : {}),
    };
  }
}

export interface TSRNNewRequestFormWorkspaceState extends WorkspaceState {
  formValue: TSRNNewRequest;
  parcels: EgibObject[];
  issueRanges: string[];
}

export enum TSRNRequestMode {
  NewRemovalNotification = 5,
  NoObjectionCertificateRequest = 6,
}
